import { Component } from '@angular/core';
import { NavItem } from '@box-types';
import { profileNavItems } from '@box-configs/nav-items.options';
import { AnalyticsService, UserService } from '@box-core/services';
import { filterValidNavItemsForUser } from '@box/utils';

@Component({
  selector: 'account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss']
})
export class AccountMenuComponent {
  public menuItems: NavItem[];

  constructor(private analyticsService: AnalyticsService, private userService: UserService) {}

  ngOnInit(): void {
    this.setAccountMenuItems();
  }

  private setAccountMenuItems() {
    const isGuest = this.userService.isGuest;
    const filteredMenuItems = filterValidNavItemsForUser(profileNavItems, isGuest);
    this.menuItems = filteredMenuItems.filter((item) => item.routerLink);
  }

  public onMenuItemClick(link: string): void {
    if (link !== '/account/settings') return;
    this.analyticsService.addGACustomEvent('click_settings', {});
  }
}
